<template>
  <div>
    <h1> {{ $t('signupAuthCode.title') }} </h1>
    <form @submit.prevent="handleSubmit">
      <div>
        <FormAuthCode v-model="form.authCode" :error="badAuthCode" />
      </div>

      <p class="description">
        {{ $t('signupAuthCode.text') }} <strong>{{ mobilePhone }}</strong>
      </p>

      <p v-if="badAuthCode" class="error">
        {{ $t('signupAuthCode.error-code') }}
      </p>

      <AuthCodeResendLink :auth-code="form.authCode" :signup-mobile-phone="mobilePhone" />

      <SignupButtons :can-be-submitted="!$v.$invalid" :is-submitting="isSubmitting" />
    </form>
  </div>
</template>

<script>
  import FormAuthCode from '@/components/Form/FormAuthCode.vue';
  import SignupButtons from '@/components/Signup/SignupButtons';
  import AuthCodeResendLink from '@/components/AuthCodeResendLink';
  import { maxLength, minLength, required } from '@byscripts/vuelidate/lib/validators';

  export default {
    name: 'SignupAuthCode',
    components: {
      AuthCodeResendLink,
      SignupButtons,
      FormAuthCode,
    },
    data() {
      return {
        form: {
          authCode: null,
        },
        isSubmitting: false,
        badAuthCode: false,
        signupError: false,
      };
    },
    validations: {
      form: {
        authCode: {
          required,
          minLength: minLength(6),
          maxLength: maxLength(6),
        },
      },
    },
    computed: {
      mobilePhone() {
        return this.$store.state.signup.form.mobilePhone;
      },
    },
    methods: {
      async handleSubmit() {
        this.badAuthCode = false;

        this.$v.$touch();

        if (this.$v.$invalid) {
          return this.$addError(this.$t('signupAuthCode.error-form'));
        }

        try {
          this.isSubmitting = true;
          this.signupError = false;

          await this.$store.dispatch('signup/saveForm', { form: this.form });
          await this.$store.dispatch('signup/register');

          return this.$router.push({ name: 'signup-summary' });
        } catch (e) {
          if (e.response?.status === 400) {
            this.form.authCode = null;
            return this.badAuthCode = true;
          }
          await this.$addError(this.$t('signupAuthCode.error'));
          throw e;
        } finally {
          this.isSubmitting = false;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .error {
    font-weight: bold;
    color: $inputErrorColor;
  }

  .description {
    font-size: 1.4rem;

    strong {
      white-space: nowrap;
    }
  }

  .auth-code-resend-link {
    margin-top: 4rem;
  }
</style>
